import { BaseApiService } from "../../../api/base";
import type {
  LoanOfferState,
  OfferRequest,
  PreliminaryOfferResponse,
} from "../types/offer";

class OfferApiService extends BaseApiService {
  async requestOffer(): Promise<OfferRequest> {
    return this.post<OfferRequest>("/wlc/offers/request-offer", {
      source: "VoltWeb",
    });
  }

  async getOferRequested(): Promise<OfferRequest> {
    return this.get<OfferRequest>(`/wlc/offers/requested`);
  }

  // Prices a preliminary offer from the BC score and declared income, before
  // KYC; the offer itself then shows up in /loans/offers.
  async requestPreliminaryOffer(): Promise<PreliminaryOfferResponse> {
    return this.post<PreliminaryOfferResponse>("/wlc/offers/preliminary", {
      source: "Web",
    });
  }

  async getLoanOfferState(): Promise<LoanOfferState> {
    return this.get<LoanOfferState>(`/loans/offers`);
  }

  // Answers no offers state: read it again for the review status.
  async uploadProofOfIncome(file: File): Promise<void> {
    const formData = new FormData();
    formData.append("docs", file);
    return this.post<void>(`/loans/offers/proof-of-income`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export const offerApiService = new OfferApiService();
